/** 与后端 UNASSIGNED_TALENT_POOL 一致：尚未划入任何人才池。 */
export const UNASSIGNED_TALENT_POOL = 'UNASSIGNED';
